var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhevCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 21,
    viewBox: "0 0 53 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0820312,
    y: 0.5,
    width: 52.9173,
    height: 20,
    rx: 10,
    fill: "#00148C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3872 18H10.5601L11.3872 12.1667H8.49243C8.01273 12.1667 8.021 11.9 8.17814 11.6167C8.33529 11.3333 8.2195 11.55 8.23604 11.5167C9.30296 9.61667 10.9075 6.78333 13.0413 3H13.8684L13.0413 8.83333H15.9361C16.3414 8.83333 16.3993 9.10833 16.3248 9.25833L16.2669 9.38333C13.0083 15.125 11.3872 18 11.3872 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8535 6V15",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3535 10.5L19.3535 10.5",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3965 6.525L44.4048 6.51667L41.328 3.41667L40.4513 4.3L42.1965 6.05833C41.419 6.35833 40.8649 7.10833 40.8649 8C40.8649 9.15 41.7912 10.0833 42.9326 10.0833C43.2303 10.0833 43.5032 10.0167 43.7596 9.90833V15.9167C43.7596 16.375 43.3874 16.75 42.9326 16.75C42.4777 16.75 42.1055 16.375 42.1055 15.9167V12.1667C42.1055 11.25 41.3611 10.5 40.4513 10.5H39.6243V4.66667C39.6243 3.75 38.8799 3 37.9701 3H33.0077C32.0979 3 31.3535 3.75 31.3535 4.66667V18H39.6243V11.75H40.8649V15.9167C40.8649 17.0667 41.7912 18 42.9326 18C44.0739 18 45.0002 17.0667 45.0002 15.9167V8C45.0002 7.425 44.7687 6.9 44.3965 6.525ZM37.9701 8.83333H33.0077V4.66667H37.9701V8.83333ZM42.9326 8.83333C42.4777 8.83333 42.1055 8.45833 42.1055 8C42.1055 7.54167 42.4777 7.16667 42.9326 7.16667C43.3874 7.16667 43.7596 7.54167 43.7596 8C43.7596 8.45833 43.3874 8.83333 42.9326 8.83333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhevCard);
export default __webpack_public_path__ + "static/media/PHEV_Card.11d33e121af884dd9f6cd7ddd3dbc974.svg";
export { ForwardRef as ReactComponent };